module.exports = __webpack_public_path__ + "img/logo.f352a6a7.png";